<template>
  <el-dialog
    title="欧易 C2C 广告快照"
    :visible="visible"
    width="900px"
    :append-to-body="true"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <div class="okx-ad-toolbar">
      <el-form size="small" inline class="ele-form-search" @submit.native.prevent>
        <el-form-item label="支付筛选">
          <el-select v-model="filterMethod" clearable placeholder="请选择" class="okx-ad-select" @change="loadList">
            <el-option v-for="item in payMethodOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="okx-ad-actions">
        <el-button size="small" type="success" icon="el-icon-refresh" class="ele-btn-icon"
          :loading="syncing" @click="syncOkxRate">同步欧易汇率</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" class="ele-btn-icon"
          :loading="loading" @click="loadList">刷新</el-button>
      </div>
    </div>

    <el-table v-loading="loading || syncing" :data="list" border stripe height="420" size="small">
      <el-table-column prop="filter_label" label="筛选" width="90" align="center" />
      <el-table-column prop="rank_no" label="名次" width="70" align="center" />
      <el-table-column prop="nick_name" label="商家" min-width="160" show-overflow-tooltip />
      <el-table-column prop="price" label="单价" width="110" align="center" />
      <el-table-column prop="payment_methods_cn" label="支付方式" min-width="140" show-overflow-tooltip />
      <el-table-column prop="sync_time_text" label="同步时间" width="160" align="center" />
    </el-table>

    <div slot="footer" class="ele-text-right">
      <el-button size="small" @click="updateVisible(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

export default {
  name: 'OkxAdDialog',
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      syncing: false,
      filterMethod: '',
      list: [],
      payMethodOptions: []
    };
  },
  mounted() {
    loadDictOptions('okx_pay_method')
      .then((list) => { this.payMethodOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  watch: {
    visible(val) {
      if (val) {
        this.filterMethod = '';
        this.loadList();
      }
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    syncOkxRate() {
      this.$confirm(
        '将拉取欧易 C2C 各支付方式前 10 条广告入库，并回写已有交易对的市场汇率（不会生成交易对），是否继续？',
        '同步欧易汇率',
        { type: 'warning' }
      ).then(() => {
        this.syncing = true;
        this.$http.post('/transmodel/syncOkxRate', { top_n: 10 }).then((res) => {
          this.syncing = false;
          if (res.data.code === 0) {
            const data = res.data.data || {};
            const rates = data.rates || {};
            this.$message.success(
              `${res.data.msg}，已入库 ${data.ad_count || 0} 条；全部 ${rates.rate_all} / 支付宝 ${rates.rate_alipay} / 银行卡 ${rates.rate_bank} / 微信 ${rates.rate_wechat}`
            );
            this.loadList();
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg || '同步失败');
          }
        }).catch((e) => {
          this.syncing = false;
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    loadList() {
      this.loading = true;
      this.$http.get('/transmodel/okxAdList', {
        params: { filter_method: this.filterMethod }
      }).then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || '加载失败');
        }
      }).catch((e) => {
        this.loading = false;
        this.$message.error(e.message);
      });
    }
  }
};
</script>

<style scoped>
.okx-ad-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.okx-ad-toolbar .ele-form-search,
.okx-ad-toolbar .el-form-item {
  margin-bottom: 0;
}
.okx-ad-select {
  width: 140px;
}
.okx-ad-actions {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
</style>
